'use es6';

import { List, Map as ImmutableMap } from 'immutable';
import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect, useSelector } from 'react-redux';
import NotificationList from 'ReduxMessenger/components/NotificationList';
import { APP_STATUS } from 'ContentEditorUI/redux/constants';
import AsyncComponentContext from 'ContentEditorUI/context/AsyncComponentContext';
import { createTracker } from 'usage-tracker';
import UsageTracker from 'ContentEditorUI/utils/UsageTracker';
import LegacyBlogBackboneDOM from '../containers/LegacyBlogBackboneDOM';
import GlobalContentModal from 'ContentEditorUI/components/modals/GlobalContentModal';
import LockedModal from 'ContentEditorUI/components/modals/LockedModal';
import { requestUninitialized } from 'redux-request-state/util/requestStateCheckers';
import LegacyBlogScaffoldingContainer from '../containers/LegacyBlogScaffoldComponent';
import FetchModuleErrors from 'ContentEditorUI/components/app/FetchModuleErrors';
import { getContentModelId, getHasContentModel } from 'ContentEditorUI/redux/selectors/baseContentModelSelectors';
import { getRoutingCurrentPage } from 'ContentEditorUI/redux/selectors/routingSelectors';
import { fetchAccountVerificationStatus } from 'ContentEditorUI/redux/actions/accountVerificationStatusActions';
import { BLOG_TYPE_NOUN_KEY } from '../i18nConstants';
import { getAppStatus, getIframeReady, getAddModuleSidebarLoaded, getIsAppReadyForSaving } from 'ContentEditorUI/redux/selectors/appStatusSelectors';
import { getShouldShowScopesHaveChangedModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import { selectIsAudioNarrationPanelOpen } from '../redux/selectors/audioNarrationSelectors';
import { getBlogLimitRequest, getBlogPostLimitRequest, getMlangBlogPostLimitRequest, getNumberOfBlogsOverLimit } from '../redux/selectors/blogLimitsSelectors';
import { fetchBrandColors as fetchBrandColorsAction } from 'ContentEditorUI/redux/actions/brandActions';
import BlogAutoSaveContainer from '../containers/BlogAutoSaveContainer';
import ShowUnpublishedBlogChangesOnStartup from '../containers/ShowUnpublishedBlogChangesOnStartup';
import ShowScheduledBlogPostHasUnpublishedChanges from '../containers/ShowScheduledBlogPostHasUnpublishedChanges';
import { autoSaveDebounced as autoSaveDebouncedAction, autoSave as autoSaveAction } from '../redux/actions/postSaveActions';
import { fetchBlogLimit, fetchBlogPostLimit, fetchMlangBlogPostLimit } from '../redux/actions/blogLimitsActions';
import { fetchNotificationEmails, fetchSocialAutoPublishStatus, fetchPostBlogs } from '../redux/actions/postSettingsActions';
import { fetchEditableSlugInfo } from 'ContentEditorUI/redux/actions/slugInfoActions';
import { closeSocialComposer } from '../redux/actions/socialComposerActions';
import { fetchDomainExclusionReason } from 'ContentEditorUI/redux/actions/portalDomainsActions';
import { getContentModelContentGroupId } from '../redux/selectors/postContentModelSelectors';
import { getContentGroupNotificationEmailIds } from '../redux/selectors/postSettingsSelectors';
import { getContentSchemaRequest } from 'ContentEditorUI/redux/selectors/requestStatesSelectors';
import { getIsDistractionFreeOpen } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { getSocialComposerOpen, getSocialComposerParams } from '../redux/selectors/socialComposerSelectors';
import SocialComposerPanel from 'social-composer-lib/components/SocialComposerPanel';
import { getHasBlogAccess } from '../redux/selectors/authSelectors';
import { renderFeedbackLoader, Surveys } from 'ContentEditorUI/lib/csatSurvey';
import { getThemePath } from 'ContentEditorUI/redux/selectors/themeSelectors';
import { getIsUserUngatedForPatagonia } from 'ContentEditorUI/redux/selectors/authSelectors';
import { getOpenModal } from 'ContentEditorUI/redux/selectors/modalSelectors';
import PatagoniaModalQueryChecker from '../containers/PatagoniaModalQueryChecker';
import { MODAL_TYPES } from 'ContentEditorUI/lib/modalConstants';
import AudioPreviewPanel from './audio/AudioPreviewPanel';
import BlogPostOperationsModalSwitch from './BlogPostOperationsModalSwitch';
import SurveyContainer from 'ContentEditorUI/containers/SurveyContainer';
import MlangLimitUpgradeModal from './MlangLimitUpgradeModal';
import { getHasSeenOnboardingModalFromSuperStore, getHasSeenBlogPlgOnboardingTourFromSuperStore, getShouldShowOnboardingModal } from 'ContentEditorUI/redux/selectors/localCachedSettingsSelectors';
import { CONSUMER_NAME } from '../Constants';
import { useQueryParams } from 'ContentEditorUI/utils/routingUtils';
import { getPostSettingsFullUrl } from '../redux/selectors/postSettingsSelectors';
import { getShareablePreviewUrl } from '../redux/selectors/urlSelectors';
import CmsSettingsModals from 'ContentEditorUI/components/modals/CmsSettingsModals';
import { BLOG_PLG_ONBOARDING_MODAL, OnboardingModal, OnboardingTourController } from './onboarding/OnboardingTour';
import events from '../../events.yaml';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const mapStateToProps = state => ({
  appIsReadyForSaving: getIsAppReadyForSaving(state),
  appStatus: getAppStatus(state),
  iframeReady: getIframeReady(state),
  hasContentModel: getHasContentModel(state),
  postId: getContentModelId(state),
  contentGroupId: getContentModelContentGroupId(state),
  contentGroupNotificationEmailIds: getContentGroupNotificationEmailIds(state),
  contentSchemaRequest: getContentSchemaRequest(state),
  contentUrl: getPostSettingsFullUrl(state),
  hasBlogAccess: getHasBlogAccess(state),
  addModuleSidebarLoaded: getAddModuleSidebarLoaded(state),
  socialComposerOpen: getSocialComposerOpen(state),
  socialComposerParams: getSocialComposerParams(state),
  currentPage: getRoutingCurrentPage(state),
  blogLimitRequest: getBlogLimitRequest(state),
  numBlogsOverLimit: getNumberOfBlogsOverLimit(state),
  shouldShowScopesHaveChangedModal: getShouldShowScopesHaveChangedModal(state),
  themePath: getThemePath(state),
  blogPostLimitRequest: getBlogPostLimitRequest(state),
  mlangBlogPostLimitRequest: getMlangBlogPostLimitRequest(state),
  isUserUngatedForPatagonia: getIsUserUngatedForPatagonia(state),
  hasSeenOnboardingModal: getHasSeenBlogPlgOnboardingTourFromSuperStore(state),
  hasSeenPatagoniaOnboardingModal: getHasSeenOnboardingModalFromSuperStore(state),
  isDistractionFreeOpen: getIsDistractionFreeOpen(state),
  isAudioNarrationPanelOpen: selectIsAudioNarrationPanelOpen(state),
  pageUrl: getShareablePreviewUrl(state)
});
const PatagoniaModalSwitch = () => {
  const openModal = useSelector(getOpenModal);
  const shouldShowOnboardingModal = useSelector(state => getShouldShowOnboardingModal(state, CONSUMER_NAME));
  if (shouldShowOnboardingModal) {
    return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
      children: ({
        PatagoniaOnboardingTourModalContainer
      }) => {
        return /*#__PURE__*/_jsx(PatagoniaOnboardingTourModalContainer, {});
      }
    });
  }
  switch (openModal) {
    case BLOG_PLG_ONBOARDING_MODAL:
      {
        return /*#__PURE__*/_jsx(OnboardingModal, {});
      }
    case MODAL_TYPES.ONBOARDING_MODAL:
      {
        return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
          children: ({
            PatagoniaOnboardingTourModalContainer
          }) => {
            return /*#__PURE__*/_jsx(PatagoniaOnboardingTourModalContainer, {});
          }
        });
      }
    case MODAL_TYPES.SETTINGS_MODAL:
      return /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          PatagoniaSettingsModalContainer
        }) => {
          return /*#__PURE__*/_jsx(PatagoniaSettingsModalContainer, {});
        }
      });
    case MODAL_TYPES.MLANG_LIMIT_UPGRADE_MODAL:
      return /*#__PURE__*/_jsx(MlangLimitUpgradeModal, {});
    default:
      return /*#__PURE__*/_jsx(BlogPostOperationsModalSwitch, {
        openModalName: openModal
      });
  }
};
const CsatSurveyModal = ({
  hasSeenOnboardingModal
}) => {
  const isNotAt = !window.SELENIUM_IS_RUNNING;
  const {
    generatedByContentIdeas = false
  } = useQueryParams();
  const shouldRenderCsat = isNotAt && hasSeenOnboardingModal && generatedByContentIdeas;
  if (!shouldRenderCsat) {
    return null;
  }
  return renderFeedbackLoader(Surveys.CI_TOPIC_SUGGESTIONS);
};
const mapDispatchToProps = {
  fetchBlogLimit,
  fetchBrandColors: fetchBrandColorsAction,
  fetchNotificationEmails,
  fetchPostBlogs,
  fetchSocialAutoPublishStatus,
  fetchEditableSlugInfo,
  closeSocialComposer,
  autoSaveDebounced: autoSaveDebouncedAction,
  fetchAccountVerificationStatus,
  autoSave: autoSaveAction,
  fetchDomainExclusionReason,
  fetchBlogPostLimit,
  fetchMlangBlogPostLimit
};

// TODO: Audit the methods used in here vs core editor / universal app container vs blog app container
class ExtraApplicationComponents extends Component {
  componentDidMount() {
    const {
      hasContentModel,
      appStatus,
      iframeReady,
      hasBlogAccess,
      postId
    } = this.props;
    // Slightly tweaked from original BlogEditorUI implementation:
    // if (requestSucceeded(this.props.contentSchemaRequest)) {
    if (hasContentModel) {
      this.props.fetchDomainExclusionReason();
      this.fetchNotificationSettingsData();
      this.props.fetchEditableSlugInfo(this.props.postId);
      this.createUsageTrackerAndTrackPageLoad();
    }
    this.props.fetchPostBlogs();
    if (hasBlogAccess) {
      this.props.fetchBlogLimit();
      this.props.fetchBlogPostLimit();
      if (postId) {
        this.props.fetchMlangBlogPostLimit(postId);
      }
    }
    this.props.fetchAccountVerificationStatus();
    if (appStatus === APP_STATUS.READY) {
      if (iframeReady) {
        this.triggerPostWholeAppReadyActions();
      }
    }
  }
  componentDidUpdate(prevProps) {
    const {
      hasContentModel,
      hasBlogAccess,
      blogLimitRequest,
      iframeReady,
      appStatus,
      blogPostLimitRequest,
      mlangBlogPostLimitRequest,
      postId
    } = this.props;
    if (!prevProps.hasContentModel && hasContentModel) {
      this.props.fetchDomainExclusionReason();
      this.fetchNotificationSettingsData();
      this.props.fetchEditableSlugInfo(this.props.postId);
      this.createUsageTrackerAndTrackPageLoad();
    }
    const previouslyFullyReady = prevProps.appStatus === APP_STATUS.READY && prevProps.iframeReady;
    const fullyReadyNow = appStatus === APP_STATUS.READY && iframeReady;
    if (!previouslyFullyReady && fullyReadyNow) {
      this.triggerPostWholeAppReadyActions();
    }
    if (hasBlogAccess) {
      if (blogLimitRequest && requestUninitialized(blogLimitRequest)) {
        this.props.fetchBlogLimit();
      }
      // TODO: add back retrying for blog post limits once the BE stops
      // returning 404s when the limit does not exist
      if (blogPostLimitRequest && requestUninitialized(blogPostLimitRequest)) {
        this.props.fetchBlogPostLimit();
      }
      if (postId && requestUninitialized(mlangBlogPostLimitRequest)) {
        this.props.fetchMlangBlogPostLimit(postId);
      }
    }
  }
  triggerPostWholeAppReadyActions() {
    const {
      fetchBrandColors
    } = this.props;
    fetchBrandColors();
  }
  createUsageTrackerAndTrackPageLoad() {
    const {
      pageUrl,
      currentPage,
      themePath,
      isDistractionFreeOpen
    } = this.props;
    if (!window.jasmine) {
      const tracker = createTracker({
        events,
        properties: {
          // Required properties
          namespace: 'blog',
          // Optional properties
          screen: 'blog-editor',
          subscreen: currentPage,
          pageType: 'blog',
          pageUrl
        },
        lastKnownEventProperties: ['screen', 'subscreen'],
        clone: true
      });
      UsageTracker.init(tracker);
    }
    UsageTracker.track('pageLoad', {
      themePath,
      distractionFreeOpen: Boolean(isDistractionFreeOpen)
    });
  }

  // Need these on load so publish modal from any screen can show
  // the correct message if user has publishing notifications on.
  fetchNotificationSettingsData() {
    this.props.fetchNotificationEmails(this.props.contentGroupNotificationEmailIds.toArray());
    this.props.fetchSocialAutoPublishStatus(this.props.contentGroupId);
  }
  renderSocialComposer() {
    return /*#__PURE__*/_jsx(SocialComposerPanel, Object.assign({}, this.props.socialComposerParams.toJS(), {
      clientTag: "blog-autopublish-customization",
      onCloseModal: this.props.closeSocialComposer,
      open: this.props.socialComposerOpen
    }));
  }
  render() {
    const {
      shouldShowScopesHaveChangedModal,
      appIsReadyForSaving,
      autoSave,
      autoSaveDebounced,
      hasSeenOnboardingModal,
      hasSeenPatagoniaOnboardingModal,
      contentUrl,
      isAudioNarrationPanelOpen
    } = this.props;
    return /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FetchModuleErrors, {}), /*#__PURE__*/_jsx(GlobalContentModal, {
        fromAppName: "blogEditor"
      }), /*#__PURE__*/_jsx(LegacyBlogBackboneDOM
      // TBD: Either refactor this out or throw it into extra containers. Prob look into what it does first though.
      , {}), /*#__PURE__*/_jsx(LockedModal, {
        contentNounKey: BLOG_TYPE_NOUN_KEY
      }), /*#__PURE__*/_jsx(AsyncComponentContext.Consumer, {
        children: ({
          BlogScopesHaveChangedModal
        }) => shouldShowScopesHaveChangedModal && /*#__PURE__*/_jsx(BlogScopesHaveChangedModal, {})
      }), /*#__PURE__*/_jsx(PatagoniaModalSwitch, {}), /*#__PURE__*/_jsx(PatagoniaModalQueryChecker, {}), /*#__PURE__*/_jsx(LegacyBlogScaffoldingContainer
      // Probably either refactor this out completely
      // or make it universal with config passed in
      , {}), /*#__PURE__*/_jsx(NotificationList, {}), /*#__PURE__*/_jsx(ShowUnpublishedBlogChangesOnStartup, {}), /*#__PURE__*/_jsx(ShowScheduledBlogPostHasUnpublishedChanges, {}), /*#__PURE__*/_jsx(BlogAutoSaveContainer, {
        autoSaveDebounced: autoSaveDebounced,
        autoSave: autoSave
        // TODO: This is some local component state currently in page application container, lots of weird was previously fully ready but now isn't checks. I wonder if we can just use a selector instead?
        ,
        isAppReadyForSaving: appIsReadyForSaving
      }), this.renderSocialComposer(), /*#__PURE__*/_jsx(CsatSurveyModal, {
        hasSeenOnboardingModal: hasSeenOnboardingModal || hasSeenPatagoniaOnboardingModal
      }), /*#__PURE__*/_jsx(SurveyContainer, {}), /*#__PURE__*/_jsx(CmsSettingsModals, {
        contentUrl: contentUrl
      }), /*#__PURE__*/_jsx(OnboardingTourController, {}), isAudioNarrationPanelOpen && /*#__PURE__*/_jsx(AudioPreviewPanel, {})]
    });
  }
}
ExtraApplicationComponents.propTypes = {
  currentPage: PropTypes.string.isRequired,
  hasContentModel: PropTypes.bool.isRequired,
  appIsReadyForSaving: PropTypes.bool.isRequired,
  appStatus: PropTypes.string.isRequired,
  iframeReady: PropTypes.bool.isRequired,
  addModuleSidebarLoaded: PropTypes.bool.isRequired,
  isPageFlaggedOrViolated: PropTypes.bool,
  id: PropTypes.number,
  category: PropTypes.number,
  contentUrl: PropTypes.string.isRequired,
  subcategory: PropTypes.string,
  pageLimitRequest: PropTypes.object,
  fetchBrandColors: PropTypes.func.isRequired,
  hasPartnerMatchingApp: PropTypes.bool,
  fetchAccountVerificationStatus: PropTypes.func.isRequired,
  shouldShowScopesHaveChangedModal: PropTypes.bool.isRequired,
  contentGroupId: PropTypes.number,
  contentGroupNotificationEmailIds: PropTypes.instanceOf(List),
  contentSchemaRequest: PropTypes.object.isRequired,
  hasBlogAccess: PropTypes.bool.isRequired,
  fetchBlogLimit: PropTypes.func.isRequired,
  fetchNotificationEmails: PropTypes.func.isRequired,
  fetchSocialAutoPublishStatus: PropTypes.func.isRequired,
  closeSocialComposer: PropTypes.func.isRequired,
  socialComposerOpen: PropTypes.bool.isRequired,
  socialComposerParams: PropTypes.instanceOf(ImmutableMap),
  fetchEditableSlugInfo: PropTypes.func.isRequired,
  fetchPostBlogs: PropTypes.func.isRequired,
  postId: PropTypes.number,
  blogLimitRequest: PropTypes.string.isRequired,
  numBlogsOverLimit: PropTypes.number.isRequired,
  fetchDomainExclusionReason: PropTypes.func.isRequired,
  autoSaveDebounced: PropTypes.func.isRequired,
  autoSave: PropTypes.func.isRequired,
  fetchBlogPostLimit: PropTypes.func.isRequired,
  fetchMlangBlogPostLimit: PropTypes.func.isRequired,
  blogPostLimitRequest: PropTypes.object.isRequired,
  mlangBlogPostLimitRequest: PropTypes.object.isRequired,
  themePath: PropTypes.string,
  isUserUngatedForPatagonia: PropTypes.bool.isRequired,
  hasSeenOnboardingModal: PropTypes.bool,
  hasSeenPatagoniaOnboardingModal: PropTypes.bool,
  isDistractionFreeOpen: PropTypes.bool,
  isAudioNarrationPanelOpen: PropTypes.bool.isRequired,
  pageUrl: PropTypes.string.isRequired
};
export default connect(mapStateToProps, mapDispatchToProps)(ExtraApplicationComponents);